
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("l1iRA", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $2Nwuj = parcelRequire("2Nwuj");


var $5nBzc = parcelRequire("5nBzc");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");


var $dAbO5 = parcelRequire("dAbO5");

var $6r7Ix = parcelRequire("6r7Ix");

var $hjUk0 = parcelRequire("hjUk0");

var $6UUyu = parcelRequire("6UUyu");

var $4cOi8 = parcelRequire("4cOi8");

var $jD7cj = parcelRequire("jD7cj");

var $1m9A2 = parcelRequire("1m9A2");

var $3VS69 = parcelRequire("3VS69");

var $g3LxX = parcelRequire("g3LxX");

var $3v7tz = parcelRequire("3v7tz");

var $fOKpq = parcelRequire("fOKpq");


var $5Ac5G = parcelRequire("5Ac5G");


var $eIwIu = parcelRequire("eIwIu");


var $ayHRb = parcelRequire("ayHRb");




parcelRequire("42omo");


var $dCemt = parcelRequire("dCemt");

var $2oKNO = parcelRequire("2oKNO");


var $izxBd = parcelRequire("izxBd");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");









var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $5n7dr = parcelRequire("5n7dr");

var $fQWPs = parcelRequire("fQWPs");

var $7Ux0V = parcelRequire("7Ux0V");

var $1u5CA = parcelRequire("1u5CA");




var $7XNwX = parcelRequire("7XNwX");

var $7lwhH = parcelRequire("7lwhH");












/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");








var $ccHMk = parcelRequire("ccHMk");


var $1Whri = parcelRequire("1Whri");


var $ghftu = parcelRequire("ghftu");


var $lGgRw = parcelRequire("lGgRw");





var $hECbK = parcelRequire("hECbK");








var $jPFXE = parcelRequire("jPFXE");


var $cgtv4 = parcelRequire("cgtv4");

const $94057edfb8ba8d7a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    buttonTitle: {
        id: "company-hub.carousel-extension.config-panel.layout.title",
        defaultMessage: "Choose a layout"
    },
    frameAboveImageLabel: {
        id: "company-hub.carousel-extension.config-panel.layouts.frame-above-image.label",
        defaultMessage: "Text with frame above image"
    },
    splitDesignLabel: {
        id: "company-hub.carousel-extension.config-panel.layouts.split-design-content.label",
        defaultMessage: "Split design"
    },
    solidColorBackgroundLabel: {
        id: "company-hub.carousel-extension.config-panel.layouts.solid-color-background.label",
        defaultMessage: "Solid color background"
    }
});


const $a2bf2f277dad4905$var$DROPDOWN_WIDTH = 241;
const $a2bf2f277dad4905$var$DROPDOWN_MAX_HEIGHT = 500;
const $a2bf2f277dad4905$var$BUTTON_CONTAINER_WIDTH = 152;
const $a2bf2f277dad4905$export$af1b061943ec63f0 = [
    {
        label: (0, $94057edfb8ba8d7a$export$defe85febe8b728c).frameAboveImageLabel,
        value: (0, $4cOi8.CommonLayout).FRAME_ABOVE_IMAGE
    },
    {
        label: (0, $94057edfb8ba8d7a$export$defe85febe8b728c).splitDesignLabel,
        value: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT
    },
    {
        label: (0, $94057edfb8ba8d7a$export$defe85febe8b728c).splitDesignLabel,
        value: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_LEFT
    },
    {
        label: (0, $94057edfb8ba8d7a$export$defe85febe8b728c).solidColorBackgroundLabel,
        value: (0, $4cOi8.CommonLayout).NO_IMAGE_BACKGROUND
    }
];
const $a2bf2f277dad4905$var$styles = {
    dropdownMenuStyles: "_1bsbn8ye _c71ldgin _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _18m91wug",
    buttonContainer: "_1bsb1llu _otyrpxbi"
};
const $a2bf2f277dad4905$export$23adc972c5b7cdfa = ({ updateFrameFormField: updateFrameFormField, frameParameters: frameParameters, contentId: contentId })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const handleUpdateLayout = (0, $42omo.useCallback)((newLayout)=>updateFrameFormField(frameParameters.cardId, {
            layout: newLayout
        }), [
        frameParameters.cardId,
        updateFrameFormField
    ]);
    const PreviewContentComponent = (0, $42omo.useCallback)(({ height: height, layout: layout })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jPFXE.CarouselLayoutRenderer), {
                testId: "carousel-spotlight-preview",
                backgroundColor: frameParameters.backgroundColor,
                height: height,
                layout: layout,
                imageData: frameParameters.imageSrc,
                title: frameParameters?.title,
                description: frameParameters?.description,
                textColor: frameParameters?.textColor,
                link: frameParameters.link,
                contentId: contentId,
                source: "carousel-spotlight-preview"
            })
        });
    }, [
        frameParameters,
        contentId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start" // editor toolbar has high z index
        ,
        zIndex: 600,
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                direction: "column",
                gap: "space.150",
                xcss: (0, $1Whri.cx)($a2bf2f277dad4905$var$styles.dropdownMenuStyles),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hECbK.LayoutOptions), {
                    updateLayout: handleUpdateLayout,
                    source: (0, $5Ac5G.carouselConfigAnalyticSource),
                    layoutOptions: $a2bf2f277dad4905$export$af1b061943ec63f0,
                    variant: "compact",
                    currentLayoutSelection: frameParameters.layout,
                    PreviewComponent: PreviewContentComponent
                })
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $a2bf2f277dad4905$var$styles.buttonContainer
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    ...triggerProps,
                    isSelected: isOpen,
                    onClick: ()=>setIsOpen(!isOpen),
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            ...iconProps,
                            size: "small"
                        }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $94057edfb8ba8d7a$export$defe85febe8b728c).buttonTitle
                    })
                })
            })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $jSnXV = parcelRequire("jSnXV");







var $inPa6 = parcelRequire("inPa6");


var $bfgIy = parcelRequire("bfgIy");


var $k00oi = parcelRequire("k00oi");





var $9EtP6 = parcelRequire("9EtP6");


var $4noo5 = parcelRequire("4noo5");


var $jQ0mm = parcelRequire("jQ0mm");



var $jCIc5 = parcelRequire("jCIc5");

var $d0hoS = parcelRequire("d0hoS");




var $iqWjJ = parcelRequire("iqWjJ");













const $6f92deb89807bbb7$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    linkFieldLabel: {
        id: "company-hub.carousel-extension.config-panel.link.field.label",
        defaultMessage: "Link"
    },
    titleFieldLabel: {
        id: "company-hub.carousel-extension.title.field.label",
        defaultMessage: "Title"
    },
    recommendedFieldLabel: {
        id: "company-hub.carousel-extension.recommended.field.label",
        defaultMessage: "(Recommended)"
    },
    descriptionFieldLabel: {
        id: "company-hub.carousel-extension.description.field.label",
        defaultMessage: "Description"
    },
    titlePlaceholder: {
        id: "company-hub.carousel-extension.title.placeholder",
        defaultMessage: "Give your frame a title"
    },
    descriptionPlaceholder: {
        id: "company-hub.carousel-extension.description.placeholder",
        defaultMessage: "Customize this frame to create a rotating carousel."
    }
});


const $5912d0e11f9fe29f$var$debouncedParametersUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((updateFrameFormField, inputPropertyToUpdate, inputIsUserEditedPropertyToUpdate, cardId, value, createAnalyticsEvent, shouldUpdateUserEdited = true)=>{
    updateFrameFormField(cardId, {
        [inputPropertyToUpdate]: value,
        [inputIsUserEditedPropertyToUpdate]: shouldUpdateUserEdited
    });
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'edited',
            actionSubject: inputPropertyToUpdate,
            source: (0, $5Ac5G.carouselConfigAnalyticSource)
        }
    }).fire();
}, 400); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5912d0e11f9fe29f$var$RecommendedWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1p1dglyw _k48pi7a9",
            __cmplp.className
        ])
    });
});
const $5912d0e11f9fe29f$var$fieldWrapperStyles = {
    fieldWrapper: "_19pkpxbi"
};
const $5912d0e11f9fe29f$var$externalSiteMatcher = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
const $5912d0e11f9fe29f$var$getFieldsToUpdateOnLinkSelect = async (selectedLink, fetchCoverImageUrl, cardImage, cardTitle, cardDescription, isTitleUserEdited, isDescriptionUserEdited, submitError)=>{
    let fieldsToUpdate = (0, $eIwIu.updateLinkAndConfluencePageId)(selectedLink.url, '', true);
    try {
        const client = new (0, $k00oi.default)();
        const queriedMetadata = await client.fetchData(selectedLink.url);
        const { name: name, image: image, summary: summary } = queriedMetadata?.data || {};
        const { objectId: objectId } = queriedMetadata?.meta || {};
        fieldsToUpdate = {
            ...fieldsToUpdate,
            ...(0, $eIwIu.updateLinkAndConfluencePageId)(selectedLink.url, objectId, true)
        };
        if (!cardTitle || isTitleUserEdited === false) {
            fieldsToUpdate[(0, $4cOi8.ITEM_FIELDS).TITLE] = name;
            fieldsToUpdate[(0, $4cOi8.ITEM_FIELDS).IS_TITLE_USER_EDITED] = false;
        }
        if (!cardDescription || isDescriptionUserEdited === false) {
            fieldsToUpdate[(0, $4cOi8.ITEM_FIELDS).DESCRIPTION] = summary;
            fieldsToUpdate[(0, $4cOi8.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED] = false;
        } // Updating imageSrc and imageAltText
        let newImageSrc = cardImage || '';
        const newImageAltText = '';
        const coverImage = await fetchCoverImageUrl(objectId, image);
        if (coverImage) {
            const isExternalSiteImage = $5912d0e11f9fe29f$var$externalSiteMatcher.test(coverImage);
            if (!(0, $iqWjJ.isUnsplashImage)(coverImage) && !isExternalSiteImage) // For custom uploaded image save it in format `contentId/imageId`
            newImageSrc = `${objectId}/${coverImage}`;
            else newImageSrc = coverImage;
        }
        fieldsToUpdate = {
            ...fieldsToUpdate,
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: newImageSrc,
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: newImageAltText
        };
    } catch (error) {
        submitError?.(error);
    }
    return fieldsToUpdate;
};
const $5912d0e11f9fe29f$export$48fc9d47b1ec72d4 = ({ frameParameters: frameParameters, updateFrameFormField: updateFrameFormField, isDisabled: isDisabled })=>{
    const { cardId: cardId, link: link, title: title, description: description, isTitleUserEdited: isTitleUserEdited, isDescriptionUserEdited: isDescriptionUserEdited, imageSrc: imageSrc, buttonStyle: // carousel v2
    buttonStyle, buttonText: buttonText } = frameParameters;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { submitError: submitError, cloudId: cloudId } = (0, $fOKpq.useProductDependencies)();
    const [titleValue, setTitleValue] = (0, $42omo.useState)(title);
    const [descriptionValue, setDescriptionValue] = (0, $42omo.useState)(description);
    const titleId = `title-field-${cardId}`;
    const descriptionId = `description-field-${cardId}`;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        setTitleValue(title);
    }, [
        title
    ]);
    (0, $42omo.useEffect)(()=>{
        setDescriptionValue(description);
    }, [
        description
    ]);
    const handleDescriptionChange = (0, $42omo.useCallback)((event)=>{
        const { value: value } = event.currentTarget;
        setDescriptionValue(value);
        $5912d0e11f9fe29f$var$debouncedParametersUpdate(updateFrameFormField, (0, $4cOi8.ITEM_FIELDS).DESCRIPTION, (0, $4cOi8.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED, cardId, value, createAnalyticsEvent, (0, $5Ac5G.carouselConfigAnalyticSource));
    }, [
        updateFrameFormField,
        cardId,
        createAnalyticsEvent
    ]);
    const handleTitleOnChange = (0, $42omo.useCallback)((event)=>{
        const { value: value } = event.currentTarget;
        setTitleValue(value.trimStart());
        $5912d0e11f9fe29f$var$debouncedParametersUpdate(updateFrameFormField, (0, $4cOi8.ITEM_FIELDS).TITLE, (0, $4cOi8.ITEM_FIELDS).IS_TITLE_USER_EDITED, cardId, value.trimStart(), createAnalyticsEvent, (0, $5Ac5G.carouselConfigAnalyticSource));
    }, [
        updateFrameFormField,
        cardId,
        createAnalyticsEvent
    ]);
    const fetchCoverImageUrl = (0, $d0hoS.useFetchCoverImage)((0, $5Ac5G.carouselConfigAnalyticSource));
    const handleSelectLink = (0, $42omo.useCallback)(async (selectedLink)=>{
        const fieldsToUpdate = await $5912d0e11f9fe29f$var$getFieldsToUpdateOnLinkSelect(selectedLink, fetchCoverImageUrl, imageSrc, title, description, isTitleUserEdited || false, isDescriptionUserEdited || false, submitError);
        updateFrameFormField(cardId, fieldsToUpdate);
    }, [
        cardId,
        imageSrc,
        title,
        description,
        isTitleUserEdited,
        isDescriptionUserEdited,
        fetchCoverImageUrl,
        updateFrameFormField,
        submitError
    ]);
    const handleClearLink = (0, $42omo.useCallback)((clearAllFields = false)=>{
        const fieldsToClear = {
            ...(0, $eIwIu.updateLinkAndConfluencePageId)('', ''),
            ...clearAllFields ? {
                buttonText: '',
                buttonStyle: (0, $4cOi8.ButtonStyle).DEFAULT
            } : {}
        };
        if (isTitleUserEdited === false) {
            fieldsToClear[(0, $4cOi8.ITEM_FIELDS).TITLE] = '';
            fieldsToClear[(0, $4cOi8.ITEM_FIELDS).IS_TITLE_USER_EDITED] = undefined;
        }
        if (isDescriptionUserEdited === false) {
            fieldsToClear[(0, $4cOi8.ITEM_FIELDS).DESCRIPTION] = '';
            fieldsToClear[(0, $4cOi8.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED] = undefined;
        }
        updateFrameFormField(cardId, fieldsToClear);
    }, [
        updateFrameFormField,
        cardId,
        isTitleUserEdited,
        isDescriptionUserEdited
    ]);
    const handleClearButton = ()=>{
        handleClearLink(true);
    };
    const updateButtonText = (0, $42omo.useCallback)((buttonTextPayload)=>{
        updateFrameFormField(cardId, {
            buttonText: buttonTextPayload
        });
    }, [
        updateFrameFormField,
        cardId
    ]);
    const updateButtonStyle = (0, $42omo.useCallback)((buttonStylePayload)=>{
        updateFrameFormField(cardId, {
            buttonStyle: buttonStylePayload
        });
    }, [
        updateFrameFormField,
        cardId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $jQ0mm.ButtonConfig), {
                cloudId: cloudId,
                link: link,
                text: buttonText,
                style: buttonStyle,
                handleSelectLink: handleSelectLink,
                handleClearLink: handleClearLink,
                handleClearButton: handleClearButton,
                updateButtonText: updateButtonText,
                updateButtonStyle: updateButtonStyle,
                source: (0, $5Ac5G.carouselContentAnalyticSource)
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                xcss: $5912d0e11f9fe29f$var$fieldWrapperStyles.fieldWrapper,
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                        htmlFor: titleId,
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $jCIc5.PanelSubheader), {
                            showUpdatedStyles: true,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $6f92deb89807bbb7$export$defe85febe8b728c).titleFieldLabel
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)($5912d0e11f9fe29f$var$RecommendedWrapper, {
                                    children: [
                                        ' ',
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $6f92deb89807bbb7$export$defe85febe8b728c).recommendedFieldLabel
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                        id: titleId,
                        value: titleValue?.trimStart(),
                        onChange: handleTitleOnChange,
                        maxLength: 255,
                        isDisabled: isDisabled,
                        placeholder: formatMessage((0, $6f92deb89807bbb7$export$defe85febe8b728c).titlePlaceholder)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                xcss: $5912d0e11f9fe29f$var$fieldWrapperStyles.fieldWrapper,
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                        htmlFor: descriptionId,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jCIc5.PanelSubheader), {
                            showUpdatedStyles: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $6f92deb89807bbb7$export$defe85febe8b728c).descriptionFieldLabel
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                        id: descriptionId,
                        rows: 3,
                        value: descriptionValue?.trimStart(),
                        onChange: handleDescriptionChange,
                        maxLength: 700,
                        isDisabled: isDisabled,
                        testId: "frame-description-field",
                        placeholder: formatMessage((0, $6f92deb89807bbb7$export$defe85febe8b728c).descriptionPlaceholder)
                    })
                ]
            })
        ]
    });
};





const $cd253c0731ac2770$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    backgroundColor: {
        id: "company-hub.carousel-extension.frame.background.color",
        defaultMessage: "Background color"
    },
    textColor: {
        id: "company-hub.carousel-extension.frame.text.color",
        defaultMessage: "Text color"
    },
    colorValidationSuccessMessage: {
        id: "company-hub.carousel-extension.frame.color-contrast.success",
        defaultMessage: "Your text and background colors work well for readability."
    },
    colorValidationFailMessage: {
        id: "company-hub.carousel-extension.frame.color-contrast.fail",
        defaultMessage: "Your text and background colors don\u2019t work well for readability."
    }
});


const $7398f533eccdc537$var$styles = {
    wrapper: "_1wpz1fhb _2lx21bp4 _19pku2gc _otyru2gc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    bgAndTextColorOptionsWrapper: "_19pkpxbi"
};
const $7398f533eccdc537$export$a2a14dc5e9bae153 = ({ contentId: contentId, frameParameters: frameParameters, initialUnsplashResults: initialUnsplashResults, isDisabled: isDisabled, showBgAndTextColorOptions: showBgAndTextColorOptions, updateFrameFormField: updateFrameFormField, showMediaPicker: showMediaPicker, showLayout: showLayout })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { cardId: cardId, imageSrc: imageSrc, imageAltText: imageAltText, confluencePageId: confluencePageId, backgroundColor: backgroundColor = (0, $eIwIu.frameNewParametersV2).backgroundColor, textColor: textColor = (0, $eIwIu.frameNewParametersV2).textColor, layout: layout } = frameParameters;
    const { isCompanyHub: isCompanyHub, enableLinkInputInMediaPicker: enableLinkInputInMediaPicker, isSSRProductInDarkMode: isSSRProductInDarkMode, branding: branding } = (0, $fOKpq.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap, textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $1u5CA.useBuiltInColorMap)(isSSRProductInDarkMode);
    const isReadableBackgroundColor = (color)=>(0, $fQWPs.isReadable)(color, textColor);
    const isReadableTextColor = (color)=>(0, $fQWPs.isReadable)(color, backgroundColor);
    const updateBackgroundColor = (bgColor)=>{
        updateFrameFormField(cardId, {
            [(0, $4cOi8.ITEM_FIELDS).BACKGROUND_COLOR]: bgColor
        });
    };
    const updateTextColor = (color)=>{
        updateFrameFormField(cardId, {
            [(0, $4cOi8.ITEM_FIELDS).TEXT_COLOR]: color
        });
    };
    const canShowImagePicker = layout !== (0, $4cOi8.CommonLayout).NO_IMAGE_BACKGROUND;
    (0, $7Ux0V.useAutoTransitioningColors)(backgroundColor, isReadableTextColor, textColor, updateTextColor, branding?.defaultParameters);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $7398f533eccdc537$var$styles.wrapper,
        children: [
            showLayout && /*#__PURE__*/ (0, $l998X.jsx)((0, $a2bf2f277dad4905$export$23adc972c5b7cdfa), {
                frameParameters: frameParameters,
                updateFrameFormField: updateFrameFormField,
                contentId: contentId
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5912d0e11f9fe29f$export$48fc9d47b1ec72d4), {
                frameParameters: frameParameters,
                isDisabled: isDisabled,
                updateFrameFormField: updateFrameFormField
            }),
            canShowImagePicker && (showMediaPicker ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7XNwX.ImageField), {
                shouldAllowLinkFromUrl: enableLinkInputInMediaPicker,
                analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource),
                itemId: cardId,
                contentId: contentId,
                imageSrc: imageSrc,
                imageAltText: imageAltText,
                updateItemFormField: updateFrameFormField
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $7lwhH.UnsplashSearchField), {
                analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource),
                idPrefix: "frame",
                itemId: cardId,
                contentId: contentId,
                confluencePageId: confluencePageId,
                imageSrc: imageSrc,
                imageAltText: imageAltText,
                initialUnsplashResults: initialUnsplashResults,
                isNoImageAllowed: false,
                updateItemFormField: updateFrameFormField
            })),
            showBgAndTextColorOptions && /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.200",
                xcss: $7398f533eccdc537$var$styles.bgAndTextColorOptionsWrapper,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        spread: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $cd253c0731ac2770$export$defe85febe8b728c).backgroundColor
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
                                builtInColorMap: hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
                                isReadableColor: isReadableBackgroundColor,
                                onChange: updateBackgroundColor,
                                value: backgroundColor,
                                pickerTitle: (0, $cd253c0731ac2770$export$defe85febe8b728c).backgroundColor,
                                validationSuccessMessage: formatMessage((0, $cd253c0731ac2770$export$defe85febe8b728c).colorValidationSuccessMessage),
                                validationFailMessage: formatMessage((0, $cd253c0731ac2770$export$defe85febe8b728c).colorValidationFailMessage),
                                showCustomPalette: isCompanyHub,
                                analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        spread: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $cd253c0731ac2770$export$defe85febe8b728c).textColor
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
                                builtInColorMap: hideDefaultColorPalette ? emptyColorMap : textColorMap,
                                isReadableColor: isReadableTextColor,
                                onChange: updateTextColor,
                                value: textColor,
                                pickerTitle: (0, $cd253c0731ac2770$export$defe85febe8b728c).textColor,
                                validationSuccessMessage: formatMessage((0, $cd253c0731ac2770$export$defe85febe8b728c).colorValidationSuccessMessage),
                                validationFailMessage: formatMessage((0, $cd253c0731ac2770$export$defe85febe8b728c).colorValidationFailMessage),
                                showCustomPalette: isCompanyHub,
                                analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource),
                                showTextIcon: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $bdecac3535434a54$var$actionSubjectIdPostFix = 'Frame';
const $bdecac3535434a54$export$3067bcb36d887961 = ({ ...framesAreaContainerProps })=>{
    const { items: items, contentId: contentId, showBgAndTextColorOptions: showBgAndTextColorOptions, showMediaPicker: showMediaPicker, showLayout: showLayout, updateFrameFormField: updateFrameFormField } = framesAreaContainerProps;
    const initialUnsplashResults = (0, $izxBd.useInitialUnsplashResults)(items);
    const renderFrameContent = (frameParameters, isFrameDisabled)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7398f533eccdc537$export$a2a14dc5e9bae153), {
            contentId: contentId,
            frameParameters: frameParameters,
            initialUnsplashResults: initialUnsplashResults,
            isDisabled: isFrameDisabled,
            showBgAndTextColorOptions: showBgAndTextColorOptions,
            showMediaPicker: showMediaPicker,
            showLayout: showLayout,
            updateFrameFormField: updateFrameFormField
        });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2oKNO.ItemsListBuilder), {
        analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource),
        actionSubjectIdPostFix: $bdecac3535434a54$var$actionSubjectIdPostFix,
        renderItemContent: renderFrameContent,
        itemLabel: (0, $dCemt.ITEM_LABEL).FRAME,
        ...framesAreaContainerProps
    });
};





const $d7698af16187cbb4$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    title: {
        id: "company-hub.carousel-extension.config-panel.title",
        defaultMessage: "Carousel"
    },
    framesInvalidMessage: {
        id: "company-hub.carousel-extension.config-panel.field.frames.error.invalid-list",
        defaultMessage: "Add frames"
    },
    preambleV2: {
        id: "company-hub.carousel-extension.config-panel.preamble-v2",
        defaultMessage: "Design a set of up to {number} rotating frames. {supportLink}"
    },
    preambleV2WithoutSupportLink: {
        id: "company-hub.carousel-extension.config-panel.preamble-v2-without-support-link",
        defaultMessage: "Design a set of up to {number} rotating frames."
    },
    preambleSupportLinkLabelV2: {
        id: "company-hub.carousel-extension.config-panel.preamble-link.label-v2",
        defaultMessage: "Learn more about carousels"
    },
    stylesTabLabel: {
        id: "company-hub.carousel-extension.config-panel.tab.styles.label",
        defaultMessage: "Styles"
    },
    contentTabLabel: {
        id: "company-hub.carousel-extension.config-panel.tab.content.label",
        defaultMessage: "Content"
    },
    styleSectionGeneralTitle: {
        id: "company-hub.carousel-extension.config-panel.style.general.title",
        defaultMessage: "General"
    },
    styleSectionNavigationTitle: {
        id: "company-hub.carousel-extension.config-panel.style.navigation.title",
        defaultMessage: "Navigation"
    },
    addFrameText: {
        id: "company-hub.carousel-extension.config-panel.add-frame-cta",
        defaultMessage: "Add frame"
    },
    updatedLozengeLabel: {
        id: "company-hub.carousel-extension.config-panel.lozenge.label.updated",
        defaultMessage: "UPDATED"
    }
});





parcelRequire("42omo");








var $aPCur = parcelRequire("aPCur");

















var $eXmBZ = parcelRequire("eXmBZ");


var $3gadb = parcelRequire("3gadb");


var $k1IsV = parcelRequire("k1IsV");







const $ece5b81ab8418f6b$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    autoplayLabel: {
        id: "company-hub.carousel-extension.config-panel.styles.autoplay-label",
        defaultMessage: "Autoplay"
    },
    autoplayTooltipContent: {
        id: "company-hub.carousel-extension.config-panel.styles.autoplay-tooltip-content",
        defaultMessage: "Set your carousel to scroll automatically every {number} seconds in view mode"
    }
});


const $75988e0875c55d97$export$20a10abef505ee19 = ({ isAutoplayEnabled: isAutoplayEnabled, updateMainFormField: updateMainFormField })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleChange = (0, $42omo.useCallback)(()=>{
        updateMainFormField({
            isAutoplayEnabled: !isAutoplayEnabled
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'toggle',
                actionSubjectId: 'autoplayToggle',
                source: (0, $5Ac5G.carouselConfigAnalyticSource)
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isAutoplayEnabled,
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $k1IsV.ToggleField), {
        label: formatMessage((0, $ece5b81ab8418f6b$export$defe85febe8b728c).autoplayLabel),
        Icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: formatMessage((0, $ece5b81ab8418f6b$export$defe85febe8b728c).autoplayTooltipContent, {
                number: (0, $5Ac5G.AUTOPLAY_SECONDS)
            }),
            position: "bottom",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                testId: "autoplay-information-icon",
                label: "autoplay-information",
                color: "var(--ds-icon-discovery, #AF59E1)"
            })
        }),
        isChecked: isAutoplayEnabled,
        onChange: handleChange
    });
};


const $25953e55e006277d$export$82b81ff3fcd805f0 = ({ isCompanyHub: isCompanyHub, isAutoplayEnabled: isAutoplayEnabled, updateMainFormField: updateMainFormField, cornerStyle: cornerStyle, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleCornerStyleChange = (newCornerStyle)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'cornerStyling',
                source: source,
                attributes: {
                    cornerStyle: newCornerStyle
                }
            }
        }).fire();
        updateMainFormField({
            cornerStyle: newCornerStyle
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $75988e0875c55d97$export$20a10abef505ee19), {
                isAutoplayEnabled: isAutoplayEnabled,
                updateMainFormField: updateMainFormField
            }),
            isCompanyHub && /*#__PURE__*/ (0, $l998X.jsx)((0, $aPCur.CornerStyleConfig), {
                cornerStyleValue: cornerStyle || (0, $eIwIu.carouselNewParametersV2).cornerStyle,
                updateCornerStyle: handleCornerStyleChange,
                roundCornerValue: (0, $4cOi8.CornerStyle).ROUNDED,
                squareCornerValue: (0, $4cOi8.CornerStyle).SQUARED
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");











var $gj7hi = parcelRequire("gj7hi");









var $kZ5GD = parcelRequire("kZ5GD");

var $3e06541cca22ea2e$exports = {};
$3e06541cca22ea2e$exports = new URL("ProgressCirclesNavigation.e2e6ad70.svg", import.meta.url).toString();

var $77c771ba77740abe$exports = {};
$77c771ba77740abe$exports = new URL("ThumbnailNavigation.7523958e.svg", import.meta.url).toString();






var $9Uxg8 = parcelRequire("9Uxg8");




const $37f7f8137c9e7d2e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    progressCirclesNavigationStyleLabel: {
        id: "company-hub.carousel-extension.config-panel.navigation.progress-circles",
        defaultMessage: "Progress circles"
    },
    thumbnailsNavigationStyleLabel: {
        id: "company-hub.carousel-extension.config-panel.navigation.thumbnails",
        defaultMessage: "Thumbnails"
    }
});


const $9d5bf13189ecc7ee$var$styles = {
    border: "_19itia51 _2rko12b0",
    borderSelected: "_1h6d1w55",
    optionContainer: "_bfhksm61 _n3tdu2gc",
    optionImage: "_18zru2gc _1bsb1osq _ca0qutpp _n3td1b66"
};
const $9d5bf13189ecc7ee$var$navigationOptions = [
    {
        navigationOption: (0, $9Uxg8.NavigationStyle).PROGRESS_CIRCLES,
        optionImage: (0, (/*@__PURE__*/$parcel$interopDefault($3e06541cca22ea2e$exports))),
        label: (0, $37f7f8137c9e7d2e$export$defe85febe8b728c).progressCirclesNavigationStyleLabel
    },
    {
        navigationOption: (0, $9Uxg8.NavigationStyle).THUMBNAILS,
        optionImage: (0, (/*@__PURE__*/$parcel$interopDefault($77c771ba77740abe$exports))),
        label: (0, $37f7f8137c9e7d2e$export$defe85febe8b728c).thumbnailsNavigationStyleLabel
    }
];
const $9d5bf13189ecc7ee$export$8be72cf8db455613 = ({ navigationType: navigationType = (0, $9Uxg8.NavigationStyle).PROGRESS_CIRCLES, updateMainFormField: updateMainFormField })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleNavigationTypeUpdate = (selectedNavigationOption)=>{
        updateMainFormField({
            navigationStyle: selectedNavigationOption
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationStyle',
                actionSubjectId: 'configPanelNavigationStyle',
                source: (0, $5Ac5G.carouselConfigAnalyticSource),
                attributes: {
                    selectedValue: selectedNavigationOption
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        spread: "space-between",
        alignBlock: "center",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
            space: "space.150",
            children: $9d5bf13189ecc7ee$var$navigationOptions.map(({ navigationOption: navigationOption, optionImage: optionImage, label: label })=>{
                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($9d5bf13189ecc7ee$var$styles.border, $9d5bf13189ecc7ee$var$styles.optionContainer, navigationType === navigationOption && $9d5bf13189ecc7ee$var$styles.borderSelected),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($9d5bf13189ecc7ee$var$styles.optionImage),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                src: optionImage,
                                alt: "",
                                testId: `${navigationOption}--image`
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kZ5GD.default), {
                            onChange: ()=>handleNavigationTypeUpdate(navigationOption),
                            value: navigationOption,
                            testId: `${navigationOption}${navigationType === navigationOption ? '--selected' : ''}`,
                            label: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "UNSAFE_small",
                                align: "center",
                                weight: "semibold",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...label
                                })
                            }),
                            isChecked: navigationType === navigationOption
                        })
                    ]
                }, navigationOption);
            })
        })
    });
};


const $1d219d304190b3f7$var$SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/add-a-trio-of-dynamic-frames-to-your-page-with-carousel/';
const $1d219d304190b3f7$var$TRIGGER_BUTTON_KEYS = [
    'Enter',
    'Spacebar',
    ' '
];
var $1d219d304190b3f7$var$TabValues = /*#__PURE__*/ function(TabValues) {
    TabValues["STYLES"] = "styles";
    TabValues["CONTENT"] = "content";
    return TabValues;
}($1d219d304190b3f7$var$TabValues || {});
const $1d219d304190b3f7$var$styles = {
    carouselListBuilderFooterWrapper: "_zulpu2gc _1rjc1ejb _1e0c1txw _2lx21bp4",
    stickyFooter: "_18zr1b66 _195gr5cr _kqsw1if8 _94n5ze3t _bfhkvuon",
    disabledContentWrapper: "_80om13gf",
    supportLinkWrapper: "_otyrx0bf"
};
const $1d219d304190b3f7$export$97c0055a2666fa5d = ({ contentId: contentId, closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { carouselActions: carouselActions, carouselParameters: carouselParameters } = (0, $eIwIu.useCarouselExtensionParametersAndActions)({
        localId: localId,
        editorActions: editorActions
    });
    const framesListRef = (0, $42omo.useRef)(null);
    const { cards: frames, isAutoplayEnabled: isAutoplayEnabled, cornerStyle: cornerStyle, navigationStyle: navigationStyle } = carouselParameters || {};
    const { addFrame: addFrame, removeFrame: removeFrame, updateFrameFormField: updateFrameFormField, updateMainFormField: updateMainFormField } = carouselActions;
    const { isCompanyHub: isCompanyHub, showConfigPreambleSupportLink: showConfigPreambleSupportLink } = (0, $fOKpq.useProductDependencies)();
    const isDisabled = (0, $3v7tz.useIsDisabledContext)();
    const CURRENT_FRAMES_LIMIT = (0, $5Ac5G.FRAMES_LIMIT_V2);
    const hasReachedFrameLimit = frames?.length >= CURRENT_FRAMES_LIMIT;
    const [tabSelected, setTabSelected] = (0, $42omo.useState)("styles");
    const { setIsInViewMode: setIsInViewMode } = (0, $g3LxX.useExtensionsActions)();
    (0, $42omo.useEffect)(()=>{
        setIsInViewMode(false);
    }, [
        setIsInViewMode
    ]);
    const handleAddFrameKeyPress = (event)=>{
        if ($1d219d304190b3f7$var$TRIGGER_BUTTON_KEYS.includes(event.key)) setTimeout(()=>{
            (framesListRef?.current?.lastChild).focus();
        }, 100);
    };
    const handleTabClick = (0, $42omo.useCallback)((tab)=>{
        setTabSelected(tab.value);
    }, []);
    const renderConfigPanelFooter = (0, $42omo.useCallback)(()=>{
        const isContentTabSelected = tabSelected === "content"; // when Carousel is disabled (ie. premium gated), don't show the footer
        if (isDisabled) return null;
        const showAddFramesButton = !hasReachedFrameLimit && isContentTabSelected;
        const showFramesErrorMessage = !frames?.length && isContentTabSelected;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $1d219d304190b3f7$var$styles.stickyFooter,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $1d219d304190b3f7$var$styles.carouselListBuilderFooterWrapper,
                children: [
                    showAddFramesButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $dAbO5.AddItemButton), {
                        addItem: addFrame,
                        label: (0, $d7698af16187cbb4$export$defe85febe8b728c).addFrameText,
                        onAddItemKeyPress: handleAddFrameKeyPress,
                        analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource),
                        actionSubjectIdSuffix: "Carousel"
                    }),
                    showFramesErrorMessage && /*#__PURE__*/ (0, $l998X.jsx)((0, $jD7cj.FormFieldErrorMessage), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $d7698af16187cbb4$export$defe85febe8b728c).framesInvalidMessage
                        })
                    }),
                    !isContentTabSelected && /*#__PURE__*/ (0, $l998X.jsx)((0, $6r7Ix.ConfigPanelFeedbackCollector), {
                        source: (0, $5Ac5G.carouselContentAnalyticSource),
                        type: (0, $4cOi8.FeedbackType).CAROUSEL
                    })
                ]
            })
        });
    }, [
        frames,
        addFrame,
        isDisabled,
        hasReachedFrameLimit,
        tabSelected
    ]);
    if (!carouselParameters) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1m9A2.NoExtensionData), {
        source: (0, $5Ac5G.carouselExtensionKey),
        isConfigPanel: true
    });
    const updateFrames = (frames)=>updateMainFormField({
            cards: frames
        });
    const tabSections = [
        {
            label: formatMessage((0, $d7698af16187cbb4$export$defe85febe8b728c).stylesTabLabel),
            value: "styles",
            tabContent: [
                {
                    sectionId: 'general',
                    title: formatMessage((0, $d7698af16187cbb4$export$defe85febe8b728c).styleSectionGeneralTitle),
                    defaultIsExpanded: true,
                    component: /*#__PURE__*/ (0, $l998X.jsx)((0, $25953e55e006277d$export$82b81ff3fcd805f0), {
                        isCompanyHub: isCompanyHub,
                        isAutoplayEnabled: isAutoplayEnabled,
                        cornerStyle: cornerStyle,
                        updateMainFormField: updateMainFormField,
                        source: (0, $5Ac5G.carouselConfigAnalyticSource)
                    })
                },
                {
                    sectionId: 'navigation',
                    title: formatMessage((0, $d7698af16187cbb4$export$defe85febe8b728c).styleSectionNavigationTitle),
                    defaultIsExpanded: false,
                    component: /*#__PURE__*/ (0, $l998X.jsx)((0, $9d5bf13189ecc7ee$export$8be72cf8db455613), {
                        updateMainFormField: updateMainFormField,
                        navigationType: navigationStyle
                    })
                }
            ]
        },
        {
            label: formatMessage((0, $d7698af16187cbb4$export$defe85febe8b728c).contentTabLabel),
            value: "content",
            tabContent: [
                {
                    sectionId: 'frames',
                    component: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                        direction: "column",
                        gap: "space.300",
                        xcss: isDisabled && $1d219d304190b3f7$var$styles.disabledContentWrapper,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bdecac3535434a54$export$3067bcb36d887961), {
                            items: frames,
                            itemsListRef: framesListRef,
                            contentId: contentId,
                            removeItem: removeFrame,
                            updateFrameFormField: updateFrameFormField,
                            updateItems: updateFrames,
                            showBgAndTextColorOptions: true,
                            showMediaPicker: true,
                            showLayout: true,
                            shouldUseCardV2UI: true
                        })
                    })
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6UUyu.ExtensionsConfigWrapper), {
        title: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $d7698af16187cbb4$export$defe85febe8b728c).title
        }),
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $ayHRb.CarouselExtensionIcon), {}),
        footerComponent: renderConfigPanelFooter,
        closeConfigPanel: closeConfigPanel,
        shouldUseCardV2Styles: true,
        lozenge: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            appearance: "inprogress",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $d7698af16187cbb4$export$defe85febe8b728c).updatedLozengeLabel
            })
        }),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $1d219d304190b3f7$var$styles.supportLinkWrapper,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...showConfigPreambleSupportLink ? (0, $d7698af16187cbb4$export$defe85febe8b728c).preambleV2 : (0, $d7698af16187cbb4$export$defe85febe8b728c).preambleV2WithoutSupportLink,
                    values: {
                        number: CURRENT_FRAMES_LIMIT,
                        supportLink: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                            target: "_blank",
                            href: $1d219d304190b3f7$var$SUPPORT_LINK,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $d7698af16187cbb4$export$defe85febe8b728c).preambleSupportLinkLabelV2
                            })
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3VS69.PremiumGateForExtensionConfigPanel), {
                feature: "premiumCarouselConfig",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hjUk0.ConfigPanelGrouping), {
                    source: (0, $5Ac5G.carouselConfigAnalyticSource),
                    tabSections: tabSections,
                    onTabClick: handleTabClick
                })
            })
        ]
    });
};
module.exports["CarouselConfigPanelContent"] = $1d219d304190b3f7$export$97c0055a2666fa5d;

});


//# sourceMappingURL=carousel-extension.232cdb61.js.map
